import { Tag } from '../../model/tagging/Tag';
import { ITag } from '../../model/tagging/ITag';
import { SearchExpression } from '../../model/search/advanced/SearchExpression';
import { Factory } from '../../services/Factory';

namespace app.controllers.project {

  export interface IBrowseControllerScope extends angular.IScope {
    organization: any;
    project: any;
    collections: any[];
    collectionIds: any[];
    collectionNames: any[];
    popoverContent: string;
    resourcesPage: any;

    pagination: {
      limit: number,
      filterString: string
    };
    DisplayMode: any;
    displayMode: any;
    sortModel: any;
    filterModel: any;
    getResourcesForList: Function;

    columnDefinitions: any[];
    dataSource: agGrid.IDatasource;

    totalResources: number;
    totalPageCount: number;
    totalFileSize: number;

    isSimplifiedReview: boolean;
    isSimplifiedBatch: boolean;
    isSimplifiedSearch: boolean; // Probably this one is un-used

    batch: any;
    reviewedTag: Tag;
    numReviewed: number;
    numNotReviewed: number;
    reviewState: string;
    ListViewCellRenderer: any;
    columnFilters: SearchExpression;
    gridLoading: boolean;
  }

  export class BrowseController {
    private datasourceGeneration = 0; // Track datasource version to ignore stale requests
    private isInitializingResourceView = false; // Guard against concurrent/rapid re-initialization
    private pendingRequests: Map<string, Promise<any>> = new Map(); // Deduplicate concurrent identical requests
    private reloadResourceDataDebounceTimer: any = null; // Debounce rapid filter changes

    constructor(private $scope: IBrowseControllerScope, private $rootScope: IRootScope, route: any, private routeParams: any, organizationService: app.services.organization.OrganizationService,
                $location, private $timeout: any, private resourceService: app.services.resources.ResourceService, accountService: app.services.account.AccountService, notificationService,
                private preferenceService: app.services.user.PreferenceService, navigationService: any, projectService: app.services.project.ProjectService,
                private collectionService: app.services.collections.CollectionService, trackService: app.services.auditing.TrackService, layerService: any,
                tagService: app.services.tagging.TagService) {

      this.$scope.collectionIds = [];
      this.$scope.initialPageLoading = true; // Hide overlay once collections load and grid starts fetching data
      this.$scope.pagination = {
        limit: 100,
        filterString: ''
      };
      this.$scope.DisplayMode = app.model.user.DisplayMode;
      this.$scope.ListViewCellRenderer = app.directives.controls.grid.renderers.ResourceCellRenderer;
      if (!(this.$scope.displayMode = preferenceService.Get(app.model.user.Preferences.DISPLAY_MODE))) {
        preferenceService.Set(app.model.user.Preferences.DISPLAY_MODE, app.model.user.DisplayMode.ListView);
        this.$scope.displayMode = preferenceService.Get(app.model.user.Preferences.DISPLAY_MODE);
      }
      this.$scope.sortModel = preferenceService.Get(app.model.user.Preferences.GRID_COLUMNS_SORT_MODEL);
      this.$scope.filterModel = preferenceService.Get(app.model.user.Preferences.GRID_COLUMNS_FILTER_MODEL);

      this.$scope.isSimplifiedReview = route.current.action == "simplified_review";
      this.$scope.isSimplifiedBatch = this.$scope.isSimplifiedReview && "batchId" in routeParams;
      this.$scope.isSimplifiedSearch = this.$scope.isSimplifiedReview && "searchId" in routeParams;
      this.$scope.reviewState = routeParams.reviewState;

      if (this.$scope.isSimplifiedBatch) {
        tagService.FindOne({projectId: routeParams.projectId, id: routeParams.batchId}).then((batchTag: any) => {
          this.$scope.batch = batchTag;

          $rootScope.$broadcast("browse.batch.selected", {
            batch: batchTag,
            reviewState: routeParams.reviewState
          });

          tagService.FindByName(routeParams.projectId, "Reviewed").then((tag) => {
            let reviewedTag = tag.data;

            let andTags = [batchTag.id];
            let notTags = [];

            if (routeParams.reviewState && routeParams.reviewState == 'reviewed' && reviewedTag) {
              andTags.push(reviewedTag.id);
            } else if (routeParams.reviewState && routeParams.reviewState == 'notReviewed' && reviewedTag) {
              notTags.push(reviewedTag.id);
            }

            preferenceService.CurrentFilter = {
              size: 1,
              projectId: routeParams.projectId,
              tags: {
                'and': andTags,
                'or': [],
                'not': notTags
              }
            };

            this.$scope.reviewedTag = reviewedTag;

          }).catch(() => {
            this.$scope.reviewedTag = null;
          });

        });

      } else {
        $rootScope.$broadcast("navigation.batch.deselect");
      }

      navigationService.setActiveTab('projects');
      projectService.FindOneOrCurrentProject({id: routeParams.projectId}).then((project: any) => {
        this.$scope.project = project;

        if (project.type === 'organization_project') {
          organizationService.FindOne({id: project.organizationId}).then((organization: any) => this.$scope.organization = organization);
        }
        projectService.SetCurrentProject(project);
      });

      this.LoadCollections();

      this.$scope.$on("DataGridSortChangedEvent", (e, sort) => {
        preferenceService.Set(Preferences.GRID_COLUMNS_SORT_MODEL, sort);
      });

      this.$scope.$on("DataGridFilterChangedEvent", (e, filter) => {
        preferenceService.Set(Preferences.GRID_COLUMNS_FILTER_MODEL, filter);
        $scope.columnFilters = DataGrid.GetSearchExpressionFromFilterModel(filter);
      });

      this.$scope.$on("DataGridRowSelectedEvent", (e, params) => {
        trackService.TrackEvent("full view link", "clicked");
        let {projectId, collectionId, id} = params.data;

        resourceService.LaunchFullView({
          projectId: projectId,
          collectionId: collectionId,
          resourceId: id,
          grid: params.grid,
          index: params.index
        });
      });

      this.$scope.$on("DataGridRowCheckedEvent", (e, params) => {
        this.$scope.resources = _.map(params.grid.api.getSelectedRows(), (r: IResource) => r.id);
      });

      this.$scope.$on("DataGridColumnsChangedEvent", (e, columns) => {
        preferenceService.Set(Preferences.GRID_COLUMNS, columns);
      });

      this.$scope.$on("DataGridColumnsResetEvent", () => {
        preferenceService.ResetGridPreferences();
        this.InitializeResourceView();
      });

      this.$scope.$on(app.services.user.PreferenceService.GetEventForPreference(Preferences.DISPLAY_MODE), (e: IAngularEvent, value: DisplayMode) => {
        this.$scope.displayMode = value;
        this.InitializeResourceView();
      });

      // Tag / filter changes: reload data in-place without replacing the
      // datasource (no spinner, grid stays visible).
      this.$scope.$on('fetchResources', () => this.ReloadResourceData());
    }

    private InitializeResourceView() {
      // Do not set up a datasource until collectionIds is populated; on first
      // digest $watch("displayMode") fires before LoadCollections() resolves and
      // collectionIds is still [].  Calling setDatasource with an empty list
      // returns 0 rows, which locks ag-Grid's row count and prevents subsequent
      // refreshInfiniteCache() calls from fetching real data.
      if (!this.$scope.collectionIds || this.$scope.collectionIds.length === 0) {
        return;
      }

      // Prevent concurrent/rapid re-initialization. If we're already in the middle of
      // initializing, don't start another one. This prevents multiple datasources from
      // being created and multiple API requests from being fired.
      if (this.isInitializingResourceView) {
        return;
      }

      this.isInitializingResourceView = true;

      // Increment generation counter to track datasource version. If InitializeResourceView
      // is called multiple times rapidly (e.g., from both event and watch on displayMode),
      // only the latest generation's responses are processed. Older requests are ignored.
      this.datasourceGeneration++;
      const generation = this.datasourceGeneration;

    const self = this;
      const dataSource = {
        rowCount: 0, // Start with 0 to prevent grid from rendering blank rows before data arrives
        getRows(params: agGrid.IGetRowsParams) {
          // Ignore requests from stale datasources (older generations)
          if (generation !== self.datasourceGeneration) {
            params.successCallback([], 0);
            return;
          }

          // Show loading state during request
          self.$scope.gridLoading = true;

          // Capture the current filter state at the time of this request
          const capturedFilterString = self.$scope.pagination.filterString || "";
          const capturedColumnFilters = DataGrid.GetSearchExpressionFromFilterModel(
            self.preferenceService.Get(Preferences.GRID_COLUMNS_FILTER_MODEL)
          );

          // Skip API call if no filter has been applied yet (empty filter on initial load)
          // Return empty results and let user apply a filter first
          if (!capturedFilterString || capturedFilterString.trim() === "") {
            self.$scope.gridLoading = false;
            params.successCallback([], 0);
            return;
          }

          // Build a request key to deduplicate identical concurrent requests
          const requestKey = JSON.stringify({
            collectionIds: self.$scope.collectionIds,
            projectId: self.routeParams.projectId,
            page: Math.floor(params.startRow / self.$scope.pagination.limit),
            limit: self.$scope.pagination.limit,
            tagFilter: capturedFilterString,
            columnFilters: capturedColumnFilters,
            sortBy: params.sortModel.length > 0 ? params.sortModel[0].colId : null,
            sortDirection: params.sortModel.length > 0 ? params.sortModel[0].sort.toUpperCase() : null
          });

          // If this exact request is already in flight, reuse the pending response
          if (self.pendingRequests.has(requestKey)) {
            self.pendingRequests.get(requestKey)!.then((resourcesPage: any) => {
              params.successCallback(resourcesPage.resources, resourcesPage.totalResources);
            }).catch(() => {
              params.successCallback([], 0);
            }).finally(() => {
              self.$scope.gridLoading = false;
            });
            return;
          }

          const promise = self.resourceService.FindAll({
            collectionIds: self.$scope.collectionIds,
            projectId: self.routeParams.projectId,
            page: Math.floor(params.startRow / self.$scope.pagination.limit),
            limit: self.$scope.pagination.limit,
            tagFilter: capturedFilterString,
            columnFilters: capturedColumnFilters,
            sortBy: params.sortModel.length > 0 ? params.sortModel[0].colId : null,
            sortDirection: params.sortModel.length > 0 ? params.sortModel[0].sort.toUpperCase() : null
          });

          // Track this request as pending
          self.pendingRequests.set(requestKey, promise);

          promise.then((resourcesPage: any) => {
            // Only process if this is still the active datasource generation
            if (generation !== self.datasourceGeneration) {
              return;
            }

            // Hide initial loading spinner once we have data
            self.$scope.initialPageLoading = false;

            self.$scope.totalResources = resourcesPage.totalResources;
            self.$scope.totalPageCount = resourcesPage.totalPageCount;
            self.$scope.totalFileSize = resourcesPage.totalFileSize;
            // Update the datasource's row count so grid knows total rows and can size correctly
            dataSource.rowCount = resourcesPage.totalResources;
            params.successCallback(resourcesPage.resources, resourcesPage.totalResources);
          }).catch((error) => {
            // Only process if this is still the active datasource generation
            if (generation !== self.datasourceGeneration) {
              return;
            }

            self.$scope.totalResources = 0;
            self.$scope.totalPageCount = 0;
            self.$scope.totalFileSize = 0;
            // Always call successCallback, even on error, to prevent blank rows
            params.successCallback([], 0);
          }).finally(() => {
            self.$scope.gridLoading = false;
            // Clean up the pending request entry
            self.pendingRequests.delete(requestKey);
          });
        }
      };

      this.$scope.sortModel = this.preferenceService.Get(Preferences.GRID_COLUMNS_SORT_MODEL);
      this.$scope.filterModel = this.preferenceService.Get(Preferences.GRID_COLUMNS_FILTER_MODEL);

      // Assign datasource immediately (not deferred) to allow ag-Grid to initialize.
      // The rowCount starts at 0 to prevent blank rows from rendering before data arrives.
      // Once getRows completes, rowCount is updated to the actual total, and the grid
      // refetches/refreshes with real data.
      if (this.preferenceService.Get(Preferences.DISPLAY_MODE) == DisplayMode.ListView) {
        this.$scope.listViewColumnDefinitions = this.preferenceService.Get(Preferences.GRID_COLUMNS);
        this.$scope.listViewDataSource = dataSource;
      } else {
        this.$scope.gridViewColumnDefinitions = this.preferenceService.Get(Preferences.GRID_COLUMNS);
        this.$scope.gridViewDataSource = dataSource;
      }

      this.$rootScope.$broadcast("stats.refresh");
      this.isInitializingResourceView = false;
    }

    // Reloads grid data in-place (no datasource replacement) after a tag,
    // filter, or other change that doesn't alter column definitions or display
    // mode.  Uses refreshInfiniteCache so existing rows stay visible.
    // Debounced to batch rapid successive calls (e.g., from SetFilter) into a single refresh.
    private ReloadResourceData() {
      // Clear any pending reload
      if (this.reloadResourceDataDebounceTimer) {
        this.$timeout.cancel(this.reloadResourceDataDebounceTimer);
      }

      // Debounce the actual refresh by 100ms to batch rapid calls
      this.reloadResourceDataDebounceTimer = this.$timeout(() => {
        this.$rootScope.$broadcast("BrowseGrid.SoftRefresh");
        this.$rootScope.$broadcast("stats.refresh");
        this.reloadResourceDataDebounceTimer = null;
      }, 100);
    }

    private async LoadCollections() {
      const collections = await this.collectionService.FindSelectedOrAll(this.routeParams.projectId);

      this.$scope.collections = collections;
      this.$scope.collectionNames = _.pluck(collections, "name");
      this.$scope.popoverContent = this.$scope.collectionNames.join(", ");
      this.$scope.collectionIds = _.pluck(collections, "id");

      // Ensure a digest cycle happens to trigger template updates with the new datasource.
      // Without this, the grid won't bind to the datasource until user interaction.
      if (!this.$scope.$$phase) {
        this.$scope.$apply();
      }

      // Now that collectionIds is populated, initialize the datasource.
      // InitializeResourceView() guards against empty collectionIds so this
      // is the first call that actually creates the ag-Grid datasource.
      this.InitializeResourceView();
    }
  }

  frontendApp.controller("BrowseController", ["$scope", "$rootScope", "$route", "$routeParams", "OrganizationService", "$location", "$timeout", "ResourceService", "AccountService", "NotificationService", "PreferenceService", "NavigationService", "ProjectService", "CollectionService", "TrackService", "LayerService", "TagService", Factory.Create(BrowseController)]);
}
